// @flow

const PRIORITY = {
	'NORMAL': 'Normal',
	'IMPORTANT': 'Important',
};

const STATUS = {
	'NEW': 'New',
	'VIEWED': 'Viewed',
};

const PRIORITY_VALUE = {
	[PRIORITY.IMPORTANT]: 'Важно',
};

const NOTIFICATION_STATUS = {
	COMPLETED_SUCCESSFULLY: 'CompletedSuccessfully', // Все записи из списка рассылки обработаны успешно
	COMPLETED_WITH_ERRORS: 'CompletedWithErrors', // Часть записей из списка рассылки обработана с ошибками.
	IN_PROGRESS: 'InProgress', // Рассылка выполняется в настоящее время.
	NEW: 'New', // Рассылка успешно создана, но еще не попала в обработку.
	ERROR: 'Error', // Обработка завершена. Все записи из списка рассылки обработаны с ошибкой.
};

const STATUS_VALUE = {
	[NOTIFICATION_STATUS.NEW]: 'Новое',
	//else undefined and not visible
};

const STATUS_COLOR = {
	[NOTIFICATION_STATUS.COMPLETED_SUCCESSFULLY]: '#00875a',
	[NOTIFICATION_STATUS.COMPLETED_WITH_ERRORS]: '#de350b',
	[NOTIFICATION_STATUS.IN_PROGRESS]: '#4c9aff',
	[NOTIFICATION_STATUS.NEW]: '#ffab00',
	[NOTIFICATION_STATUS.ERROR]: '#de350b',
};

export {
	PRIORITY_VALUE,
	STATUS_VALUE,
	PRIORITY,
	STATUS,
	STATUS_COLOR,
};
